import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { RootState } from 'store';
import { isOAuthFlowActive } from 'utilities/oauthBridge';

export function AuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  return userAuth?.isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to='/' />
  );
}

export function UnAuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  const guestMode = useAppSelector((state: RootState) => state.guestMode);
  const location = useLocation();
  const oauthActive = isOAuthFlowActive();
  const isOAuthAuthPath =
    oauthActive && (location.pathname === '/signin' || location.pathname === '/consent');

  React.useEffect(() => {
    // Location change observer (kept for future side effects)
  }, [location]);

  // OAuth external clients stay on /signin or /consent — never force /home
  if (
    !userAuth?.isLoggedIn ||
    location.pathname === '/privacy' ||
    location.pathname === '/consent' ||
    isOAuthAuthPath
  ) {
    return <Outlet />;
  }

  if (userAuth?.isLoggedIn && location.pathname === '/signin' && guestMode?.redirectTo) {
    return <Navigate to={guestMode.redirectTo} />;
  }

  return <Navigate to='/home' />;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { AuthenticateRoutes, UnAuthenticateRoutes };
